import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import List from '@material-ui/core/List';
import Paper from '@material-ui/core/Paper';
import Toolbar from '@material-ui/core/Toolbar';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import IconButton from '@material-ui/core/IconButton';
import AppBar from '@material-ui/core/AppBar';
import getData from './../../data-services/api';
import Loader from './../../components/CustomLoader';
import client from './../../utils/apolloClient';
import { getUser } from './../../data-services/queries';
import Divider from '@material-ui/core/Divider';
import Select from 'react-select';
import gql from 'graphql-tag';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import SwipeableViews from 'react-swipeable-views';
import Execution from '../../images/settings.png';
import Waiting from '../../images/wait.png';
import Planning from '../../images/writing.png';
import Confirm from '../../images/confirm.png';
import Verified from '../../images/verified.png';
import Cancelled from '../../images/prohibition.png';
import { connect } from 'react-redux';
import { setWorkshopAmmdList } from '../../redux/actions/actions';

const styles = (theme) => ({
    fab: {
        right: 0,
        bottom: 0,
        position: 'fixed',
        margin: '20px',
    },
    extendedIcon: {
        marginRight: theme.spacing.unit,
    },
});

const RederWorkshopList = withRouter((props) => {
    const { history, workshops, filterState } = props;
    const { cmdiFilter, fcpFilter, stageFilter } = filterState;
    return (
        <List>
            {workshops ? (
                workshops.map((workshop) => {
                    return (
                        <Paper
                            elevation={2}
                            style={{ padding: 5 }}
                            key={workshop.id}
                            // square={true}
                            onClick={() => {
                                history.push({
                                    pathname: '/workshop',
                                    state: {
                                        cmdiFilter,
                                        fcpFilter,
                                        stageFilter,
                                    },
                                    // id, workshopSFID, source, stagename
                                    search: `?id=${workshop.id}&workshopSFID=${
                                        workshop.sfid
                                    }&source='listWorkshopsAMMD'&stagename=${workshop.stagename}`,
                                });
                            }}
                        >
                            <Grid container spacing={8} alignItems="center">
                                <Grid item xs={5} style={{ paddingLeft: 10 }}>
                                    <Typography align="left" variant="body2" component="">
                                        {workshop.name}
                                    </Typography>
                                    <Typography align="left" variant="caption" component="p">
                                        {workshop.start_date_time__c}
                                    </Typography>
                                </Grid>
                                <Grid item xs={2}>
                                    <Typography align="left" variant="body1">
                                        {workshop.cmdi_name__c}
                                    </Typography>
                                </Grid>
                                <Grid item xs={3}>
                                    <Typography align="left" variant="body1">
                                        {workshop.fcpname__c}
                                    </Typography>
                                    <Typography align="left">{workshop.stagename}</Typography>
                                </Grid>
                                <Grid item xs={2}>
                                    <Typography align="left">
                                        {workshop.stagename === 'Planning' && (
                                            <img
                                                src={Planning}
                                                style={{
                                                    width: '30px',
                                                    paddingLeft: '10px',
                                                }}
                                                alt="img"
                                            />
                                        )}
                                        {workshop.stagename ===
                                            'Awaiting Workshop Confirmation' && (
                                            <img
                                                src={Waiting}
                                                style={{
                                                    width: '30px',
                                                    paddingLeft: '10px',
                                                }}
                                                alt="img"
                                            />
                                        )}
                                        {workshop.stagename === 'Awaiting AMMD Approval' && (
                                            <img
                                                src={Waiting}
                                                style={{
                                                    width: '30px',
                                                    paddingLeft: '10px',
                                                }}
                                                alt="img"
                                            />
                                        )}
                                        {workshop.stagename === 'AMMD Confirmation' && (
                                            <img
                                                src={Confirm}
                                                style={{
                                                    width: '30px',
                                                    paddingLeft: '10px',
                                                }}
                                                alt="img"
                                            />
                                        )}
                                        {workshop.stagename === 'Execution' && (
                                            <img
                                                src={Execution}
                                                style={{
                                                    width: '35px',
                                                    paddingLeft: '10px',
                                                }}
                                                alt="img"
                                            />
                                        )}
                                        {workshop.stagename === 'CMDI Verification' && (
                                            <img
                                                src={Verified}
                                                style={{
                                                    width: '30px',
                                                    paddingLeft: '10px',
                                                }}
                                                alt="img"
                                            />
                                        )}
                                        {workshop.stagename === 'Paid' && (
                                            <img
                                                src={Confirm}
                                                style={{
                                                    width: '30px',
                                                    paddingLeft: '10px',
                                                }}
                                                alt="img"
                                            />
                                        )}
                                        {workshop.stagename === 'Cancelled' && (
                                            <img
                                                src={Cancelled}
                                                style={{
                                                    width: '30px',
                                                    paddingLeft: '10px',
                                                }}
                                                alt="img"
                                            />
                                        )}
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Paper>
                    );
                })
            ) : (
                <Grid container spacing={8} justify="center" alignItems="center">
                    <Grid item>
                        <Typography align="center" variant="h6">
                            No Record Present
                        </Typography>
                    </Grid>
                </Grid>
            )}
        </List>
    );
});

class ListWorkshopsAMMD extends React.Component {
    constructor(props) {
        super(props);
        const cmdiFilt = this.props.location.state ? this.props.location.state.cmdiFilter : 'All';
        const fcpFilt = this.props.location.state ? this.props.location.state.fcpFilter : 'All';
        const stageFil = this.props.location.state ? this.props.location.state.stageFilter : 'All';
        this.state = {
            value: 0,
            loading: true,
            workshops: [],
            cmdiNameList: [{ name: 'All' }],
            fcpNameList: [{ name: 'All' }],
            cmdiFilter: cmdiFilt,
            fcpFilter: fcpFilt,
            stageFilter: stageFil,
            ApprovedList: [],
            AwaitingList: [],
        };
    }

    async componentDidMount() {
        try {
            // 1. Fetch user
            const { data } = await client.query({ query: gql(getUser) });
            const userData = data.user;

            if (!userData || userData.role !== 'AMMD') {
                return;
            }
            this.setState({ loading: true });
            this.setState({ userData });
            const newSFID = userData.sfid;

            const { setWorkshopAmmdList, workshopAmmdList } = this.props;

            if (workshopAmmdList && workshopAmmdList.length > 0) {
                this.setState({ loading: true });
                this.setState({
                    workshops: workshopAmmdList,
                });
            }

            // 2. Kick off heavy + light queries in parallel
            const workshopPromise = getData(`
            SELECT * FROM salesforce.Opportunity 
            WHERE StageName IN ('AMMD Confirmation', 'Execution', 'CMDI Verification') 
              AND assigned_ammd__c = '${newSFID}' 
              AND start_date_time__c >= (MAKE_DATE(
                  CASE WHEN EXTRACT(MONTH FROM CURRENT_DATE) >= 4 
                  THEN EXTRACT(YEAR FROM CURRENT_DATE)::int 
                  ELSE (EXTRACT(YEAR FROM CURRENT_DATE) - 1)::int END, 4, 1)) 
              AND start_date_time__c <= CURRENT_DATE
        `);

            const [cmdiList, fcpList, ammdDataRaw] = await Promise.all([
                getData(`
                SELECT SFId, Id, Name, Type__c, Email__c, Reporting_To_AMMD__c, MDIcode__c 
                FROM salesforce.Pidilite_User__c 
                WHERE Reporting_To_AMMD__c = '${newSFID}'
            `),
                getData(`
                SELECT DISTINCT(FCPName__c) as fcpname__c
                FROM salesforce.Opportunity 
                WHERE StageName IN ('AMMD Confirmation', 'Execution', 'CMDI Verification') 
                  AND assigned_ammd__c = '${newSFID}'
            `),
                getData(`
                SELECT * FROM salesforce.Pidilite_User__c WHERE sfid='${newSFID}'
            `),
            ]);

            // 3. Process light queries first (UI responsiveness)
            const cmdiNameList = cmdiList.result.map((item) => ({
                name: item.name,
            }));
            const fcpNameList = fcpList.result.map((item) => ({
                name: item.fcpname__c,
            }));
            const ammdData = ammdDataRaw.result[0] || {};

            this.setState({ cmdiNameList, fcpNameList, ammdData });


            // 4. Once heavy query resolves, process workshops
            workshopPromise.then((workshopData) => {
                const workshops = workshopData.result || [];
                setWorkshopAmmdList(workshops);
            });

            // 5. Apply filters early (using props if available)
            const { location } = this.props;
            const cmdiFilt = location.state.cmdiFilter || 'All';
            const fcpFilt = location.state.fcpFilter || 'All';
            const stageFil = location.state.stageFilter || 'All';

            this.handleFilterCMDI(cmdiFilt);
            this.handleFIlterFCP(fcpFilt);
            this.handleFilterStage(stageFil);
        } catch (error) {
            console.error('Error fetching data', error);
            this.setState({ loading: false });
        }
    }

    // ✅ Listen to redux changes
    componentDidUpdate(prevProps) {
        if (prevProps.workshopAmmdList !== this.props.workshopAmmdList) {
            const workshops = this.props.workshopAmmdList || [];
            const ApprovedList = workshops
                .filter((w) => ['Execution', 'CMDI Verification'].includes(w.stagename))
                .sort((a, b) => new Date(b.createddate) - new Date(a.createddate));
            const AwaitingList = workshops
                .filter((w) => w.stagename === 'AMMD Confirmation')
                .sort((a, b) => new Date(b.createddate) - new Date(a.createddate));
            this.setState({
                workshops,
                ApprovedList,
                AwaitingList,
                loading: false,
            });
        }
    }

    handleChange = (event, value) => {
        this.setState({ value });
        this.handleFilterCMDI('All');
        this.handleFIlterFCP('All');
        this.handleFilterStage('All');
        this.setState({
            cmdiFilter: 'All',
            fcpFilter: 'All',
            stageFilter: 'All',
        });
    };

    handleChangeIndex = (index) => {
        this.setState({ value: index });
    };

    handleFilterCMDI = (cmdi) => {

        this.setState({ cmdiFilter: cmdi });
        const filteredList = this.state.workshops.filter((workshop) =>
            cmdi === 'All'
                ? this.state.fcpFilter === 'All'
                    ? this.state.stageFilter === 'All'
                        ? this.state.value === 0
                            ? workshop.stagename === 'AMMD Confirmation'
                            : workshop.stagename === 'Execution' ||
                              workshop.stagename === 'CMDI Verification'
                        : workshop.stagename === this.state.stageFilter
                    : this.state.stageFilter === 'All'
                      ? this.state.value === 0
                          ? workshop.fcpname__c === this.state.fcpFilter &&
                            workshop.stagename === 'AMMD Confirmation'
                          : workshop.fcpname__c === this.state.fcpFilter &&
                            (workshop.stagename === 'Execution' ||
                                workshop.stagename === 'CMDI Verification')
                      : workshop.fcpname__c === this.state.fcpFilter &&
                        workshop.stagename === this.state.stageFilter
                : this.state.fcpFilter === 'All'
                  ? this.state.stageFilter === 'All'
                      ? this.state.value === 0
                          ? workshop.cmdi_name__c === cmdi &&
                            workshop.stagename === 'AMMD Confirmation'
                          : workshop.cmdi_name__c === cmdi &&
                            (workshop.stagename === 'Execution' ||
                                workshop.stagename === 'CMDI Verification')
                      : workshop.stagename === this.state.stageFilter &&
                        workshop.cmdi_name__c === cmdi
                  : this.state.stageFilter === 'All'
                    ? this.state.value === 0
                        ? workshop.cmdi_name__c === cmdi &&
                          workshop.fcpname__c === this.state.fcpFilter &&
                          workshop.stagename === 'AMMD Confirmation'
                        : workshop.cmdi_name__c === cmdi &&
                          workshop.fcpname__c === this.state.fcpFilter &&
                          (workshop.stagename === 'Execution' ||
                              workshop.stagename === 'CMDI Verification')
                    : workshop.cmdi_name__c === cmdi &&
                      workshop.fcpname__c === this.state.fcpFilter &&
                      workshop.stagename === this.state.stageFilter
        );

        const sortedList = filteredList.sort(
            (a, b) => new Date(b.createddate) - new Date(a.createddate)
        );
        this.state.value === 0
            ? this.setState({ AwaitingList: sortedList })
            : this.setState({ ApprovedList: sortedList });
    };

    handleFilterStage = (stage) => {
        this.setState({ stageFilter: stage });
        const filteredList = this.state.workshops.filter((workshop) =>
            stage === 'All'
                ? this.state.fcpFilter === 'All'
                    ? this.state.cmdiFilter === 'All'
                        ? this.state.value === 0
                            ? workshop.stagename === 'AMMD Confirmation'
                            : workshop.stagename === 'Execution' ||
                              workshop.stagename === 'CMDI Verification'
                        : this.state.value === 0
                          ? workshop.cmdi_name__c === this.state.cmdiFilter &&
                            workshop.stagename === 'AMMD Confirmation'
                          : workshop.cmdi_name__c === this.state.cmdiFilter &&
                            (workshop.stagename === 'Execution' ||
                                workshop.stagename === 'CMDI Verification')
                    : this.state.cmdiFilter === 'All'
                      ? this.state.value === 0
                          ? workshop.fcpname__c === this.state.fcpFilter &&
                            workshop.stagename === 'AMMD Confirmation'
                          : workshop.fcpname__c === this.state.fcpFilter &&
                            (workshop.stagename === 'Execution' ||
                                workshop.stagename === 'CMDI Verification')
                      : this.state.value === 0
                        ? workshop.fcpname__c === this.state.fcpFilter &&
                          workshop.cmdi_name__c === this.state.cmdiFilter &&
                          workshop.stagename === 'AMMD Confirmation'
                        : workshop.fcpname__c === this.state.fcpFilter &&
                          workshop.cmdi_name__c === this.state.cmdiFilter &&
                          (workshop.stagename === 'Execution' ||
                              workshop.stagename === 'CMDI Verification')
                : this.state.fcpFilter === 'All'
                  ? this.state.cmdiFilter === 'All'
                      ? workshop.stagename === stage
                      : workshop.cmdi_name__c === this.state.cmdiFilter &&
                        workshop.stagename === stage
                  : this.state.cmdiFilter === 'All'
                    ? workshop.fcpname__c === this.state.fcpFilter && workshop.stagename === stage
                    : workshop.fcpname__c === this.state.fcpFilter &&
                      workshop.cmdi_name__c === this.state.cmdiFilter &&
                      workshop.stagename === stage
        );
        const sortedList = filteredList.sort(
            (a, b) => new Date(b.createddate) - new Date(a.createddate)
        );
        this.state.value === 0
            ? this.setState({ AwaitingList: sortedList })
            : this.setState({ ApprovedList: sortedList });
    };

    handleFIlterFCP = (fcp) => {
        this.setState({ fcpFilter: fcp });
        const filteredList = this.state.workshops.filter((workshop) =>
            fcp === 'All'
                ? this.state.cmdiFilter === 'All'
                    ? this.state.stageFilter === 'All'
                        ? this.state.value === 0
                            ? workshop.stagename === 'AMMD Confirmation'
                            : workshop.stagename === 'Execution' ||
                              workshop.stagename === 'CMDI Verification'
                        : workshop.stagename === this.state.stageFilter
                    : this.state.stageFilter === 'All'
                      ? this.state.value === 0
                          ? workshop.cmdi_name__c === this.state.cmdiFilter &&
                            workshop.stagename === 'AMMD Confirmation'
                          : workshop.cmdi_name__c === this.state.cmdiFilter &&
                            (workshop.stagename === 'Execution' ||
                                workshop.stagename === 'CMDI Verification')
                      : workshop.cmdi_name__c === this.state.cmdiFilter &&
                        workshop.stagename === this.state.stageFilter
                : this.state.cmdiFilter === 'All'
                  ? this.state.stageFilter === 'All'
                      ? this.state.value === 0
                          ? workshop.fcpname__c === fcp &&
                            workshop.stagename === 'AMMD Confirmation'
                          : workshop.fcpname__c === fcp &&
                            (workshop.stagename === 'Execution' ||
                                workshop.stagename === 'CMDI Verification')
                      : workshop.fcpname__c === fcp && workshop.stagename === this.state.stageFilter
                  : this.state.stageFilter === 'All'
                    ? this.state.value === 0
                        ? workshop.fcpname__c === fcp &&
                          workshop.cmdi_name__c === this.state.cmdiFilter &&
                          workshop.stagename === 'AMMD Confirmation'
                        : workshop.fcpname__c === fcp &&
                          workshop.cmdi_name__c === this.state.cmdiFilter &&
                          (workshop.stagename === 'Execution' ||
                              workshop.stagename === 'CMDI Verification')
                    : workshop.fcpname__c === fcp &&
                      workshop.cmdi_name__c === this.state.cmdiFilter &&
                      workshop.stagename === this.state.stageFilter
        );

        const sortedList = filteredList.sort(
            (a, b) => new Date(b.createddate) - new Date(a.createddate)
        );
        this.state.value === 0
            ? this.setState({ AwaitingList: sortedList })
            : this.setState({ ApprovedList: sortedList });
    };

    handleSorting = (sortIn) => {
        let list = this.state.value === 0 ? this.state.AwaitingList : this.state.ApprovedList;
        let sortedList;
        if (sortIn === 'asc')
            sortedList = list.sort((a, b) => new Date(a.createddate) - new Date(b.createddate));
        else sortedList = list.sort((a, b) => new Date(b.createddate) - new Date(a.createddate));

        this.state.value === 0
            ? this.setState({ AwaitingList: sortedList })
            : this.setState({ ApprovedList: sortedList });
    };

    render() {
        const { classes, history } = this.props;
        return (
            <div>
                <AppBar position="static">
                    <Toolbar>
                        <IconButton
                            className={classes.menuButton}
                            color="inherit"
                            aria-label="Menu"
                            onClick={() => {
                                // history.goBack();
                                history.push({ pathname: '/homeAMMD' });
                            }}
                        >
                            <ArrowBackIcon />
                        </IconButton>
                        <Typography variant="title" color="inherit" className={classes.flex}>
                            Workshops
                        </Typography>
                    </Toolbar>
                </AppBar>
                {/* style={{position: "fixed", width:"100%", zIndex:1}}        */}
                <Paper>
                    <Tabs
                        value={this.state.value}
                        onChange={this.handleChange}
                        indicatorColor="primary"
                        textColor="primary"
                        variant="fullWidth"
                    >
                        <Tab label={`Awaiting Approval (${this.state.AwaitingList.length})`} />
                        <Tab label={`Approved (${this.state.ApprovedList.length})`} />
                    </Tabs>
                </Paper>
                <Paper>
                    <Divider />
                    <Grid container spacing={10} padding="50px" alignItems="center">
                        <Grid item xs={3}>
                            <Typography component="span" style={{ paddingLeft: 50, padding: 10 }}>
                                <Select
                                    name="cmdiName"
                                    placeholder="CMDI Name"
                                    onChange={(e) => this.handleFilterCMDI(e.value)}
                                    value={
                                        this.state.cmdiFilter
                                            ? { label: this.state.cmdiFilter }
                                            : null
                                    }
                                    options={this.state.cmdiNameList.map((cmdiName) => ({
                                        value: cmdiName.name,
                                        label: cmdiName.name,
                                    }))}
                                />
                            </Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <Typography component="span" style={{ paddingLeft: 50, padding: 10 }}>
                                <Select
                                    name="fcpName"
                                    placeholder="FCP Name"
                                    onChange={(e) => this.handleFIlterFCP(e.value)}
                                    value={
                                        this.state.fcpFilter
                                            ? { label: this.state.fcpFilter }
                                            : null
                                    }
                                    options={this.state.fcpNameList.map((fcpName) => ({
                                        value: fcpName.name,
                                        label: fcpName.name,
                                    }))}
                                />
                            </Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <Typography component="span" style={{ paddingRight: 50, padding: 10 }}>
                                <Select
                                    name="stageName"
                                    placeholder="Stage Name"
                                    onChange={(e) => this.handleFilterStage(e.value)}
                                    value={
                                        this.state.stageFilter
                                            ? { label: this.state.stageFilter }
                                            : null
                                    }
                                    options={
                                        this.state.value === 0
                                            ? [
                                                  {
                                                      value: 'All',
                                                      label: 'All',
                                                  },
                                                  {
                                                      value: 'AMMD Confirmation',
                                                      label: 'AMMD Confirmation',
                                                  },
                                              ]
                                            : [
                                                  {
                                                      value: 'All',
                                                      label: 'All',
                                                  },
                                                  {
                                                      value: 'Execution',
                                                      label: 'Execution',
                                                  },
                                                  {
                                                      value: 'CMDI Verification',
                                                      label: 'CMDI Verification',
                                                  },
                                              ]
                                    }
                                />
                            </Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <Typography component="span" style={{ paddingRight: 50, padding: 10 }}>
                                <Select
                                    name="sortby"
                                    placeholder="Sort By"
                                    onChange={(e) => this.handleSorting(e.value)}
                                    options={[
                                        { value: 'asc', label: 'asc' },
                                        { value: 'desc', label: 'desc' },
                                    ]}
                                />
                            </Typography>
                        </Grid>
                    </Grid>
                    <Divider />
                </Paper>

                {this.state.loading ? (
                    <Grid container alignItems="center" justify="center">
                        <Loader type="Audio" color="#00BFFF" height="50" width="50" />
                    </Grid>
                ) : (
                    <SwipeableViews index={this.state.value} onChangeIndex={this.handleChangeIndex}>
                        <RederWorkshopList
                            workshops={this.state.AwaitingList}
                            filterState={this.state}
                        />
                        <RederWorkshopList
                            workshops={this.state.ApprovedList}
                            filterState={this.state}
                        />
                    </SwipeableViews>
                )}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return { workshopAmmdList: state.workshopAmmdList.data };
};
const mapDispatchToProps = { setWorkshopAmmdList };

// Connect and export single default
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(ListWorkshopsAMMD));
